import { camelToKebab, CamelToKebabCase } from '@/utils/camelToKebab';

export interface TrackingProps {
  category?: string;
  name?: string;
  extraInfo?: string | object;
  url?: string;
  placement?: string;
}

type TrackingAttributes = {
  [K in keyof TrackingProps as `data-cts-object-${K extends string ? CamelToKebabCase<K> : never}`]: string;
};

export const withTrackingAttributes = (props?: TrackingProps): TrackingAttributes => {
  if (!props) {
    return {} as TrackingAttributes;
  }

  return Object.keys(props).reduce((current, key) => {
    const ctsName = `data-cts-object-${camelToKebab(key)}` as keyof TrackingAttributes;
    const trackingValue = props[key as keyof TrackingProps];

    switch (typeof trackingValue) {
      case 'object':
        current[ctsName] = JSON.stringify(trackingValue);
        break;
      default:
        current[ctsName] = String(trackingValue);
        break;
    }

    return current;
  }, {} as TrackingAttributes);
};
